import React, {forwardRef} from 'react';
import styled, {css} from 'styled-components';
import {RowSection, tabletAndUp} from '@aboutyou/ui-components';

const BASKET_SPLITVIEW_DISPLAY = '--basket-splitview-display';
const BASKET_SPLITVIEW_RATIO_WIDTH_VAR_FIRST_CHILD =
  '--basket-splitview-ratio-width-first-child';
const BASKET_SPLITVIEW_RATIO_WIDTH_VAR_SECOND_CHILD =
  '--basket-splitview-ratio-width-second-child';

interface BasketSplitViewProps {
  contentStart: React.ReactNode;
  contentEnd: React.ReactNode;
}

/**
 * This is a hack!!!
 *
 * Do not use this as an good practice example! Always try to solve it
 * with Styled-Component props, unless your very specific
 * implementation leaves You no other option.
 *
 *
 * @param isSplit
 * Decide whether the contents should be rendered in a splitview or
 * in blocks.
 */
export const updateBasketSplitView = ({isSplit}: {isSplit: boolean}): void => {
  document.body.style.setProperty(
    BASKET_SPLITVIEW_DISPLAY,
    isSplit ? 'flex' : 'block',
  );
  document.body.style.setProperty(
    BASKET_SPLITVIEW_RATIO_WIDTH_VAR_FIRST_CHILD,
    isSplit ? '65%' : '100%',
  );
  document.body.style.setProperty(
    BASKET_SPLITVIEW_RATIO_WIDTH_VAR_SECOND_CHILD,
    isSplit ? '35%' : '100%',
  );
};

export const BasketSplitView = forwardRef<HTMLDivElement, BasketSplitViewProps>(
  function BasketSplitView(props, ref) {
    return (
      <RowSection>
        <SplitArea ref={ref as React.MutableRefObject<HTMLInputElement>}>
          <SectionStart>{props.contentStart}</SectionStart>
          <SectionEnd>{props.contentEnd}</SectionEnd>
        </SplitArea>
      </RowSection>
    );
  },
);

const SectionStart = styled.section`
  width: 50%;
  ${tabletAndUp(css`
    width: var(${BASKET_SPLITVIEW_RATIO_WIDTH_VAR_FIRST_CHILD}, 65%);
  `)}
`;

const SectionEnd = styled.section`
  width: 50%;
  ${tabletAndUp(css`
    width: var(${BASKET_SPLITVIEW_RATIO_WIDTH_VAR_SECOND_CHILD}, 35%);
  `)}
`;

const SplitArea = styled.div`
  display: var(${BASKET_SPLITVIEW_DISPLAY}, flex);
  gap: calc(2.7vw + 5px);
  flex-direction: row;
`;
